module.exports = __webpack_public_path__ + "img/icon-bank.b7cece5c.svg";